import { render, staticRenderFns } from "./InvestRiskType.vue?vue&type=template&id=6c5688fe&"
import script from "./InvestRiskType.vue?vue&type=script&lang=js&"
export * from "./InvestRiskType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports